/* global google */
/* global jQuery */
/* global moment*/
/* global require */
angular
  .module('ordersSubscriptionAdd')
  .component('ordersSubscriptionAdd', {
    template: require('./orders-subscription-add.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService', 'uiGmapGoogleMapApi', 'CenterInfo',
      function OrdersSubscriptionController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService, uiGmapGoogleMapApi, CenterInfo) {
        const APIURL = envService.read('apiUrl');
        $scope.showEmployeeView = $rootScope.gShowEmployeeView;
        $scope.showUserView = $rootScope.gShowUserView;
        $rootScope.mainmenu = 'orders';
        $rootScope.menu = 'subscription';
        $scope.map = { control: {}, center: { latitude: CenterInfo.center.latitude, longitude: CenterInfo.center.longitude }, zoom: 13 };
        $scope.order = { USER_ADDR: '', USER_ADDR2: '', ORDER_OUTSIDE_YN: 'N', PAYMENT_METHOD: '08', TB_SUBSCRIPTION_PRODUCT_ID: -1, TB_USER_CARINFO_ID: -1 };

        $scope.submit = () => {
          if (!$scope.order.user) {
            alert($translate.instant('주문자를 선택해주세요.'));
            return;
          }
          if (!$scope.order.employee) {
            alert($translate.instant('테크니션을 선택해주세요.'));
            return;
          }
          if (!$scope.order.USER_ADDR2 || $scope.order.USER_ADDR2.length < 1) {
            alert($translate.instant('상세주소를 입력해주세요.'));
            return;
          }
          if ($scope.order.TB_USER_CARINFO_ID < 1) {
            alert($translate.instant('차량을 선택해주세요.'));
            return;
          }
          if ($scope.order.TB_SUBSCRIPTION_PRODUCT_ID < 1) {
            alert($translate.instant('상품을 선택해주세요.'));
            return;
          }
          if (!$scope.order.START_DATE || $scope.order.START_DATE.length < 1) {
            alert($translate.instant('시작일을 선택해주세요'));
            return;
          }
          if (!$scope.order.SERVICE_HOUR || $scope.order.SERVICE_HOUR.length < 1) {
            alert($translate.instant('방문시간을 선택해주세요'));
            return;
          }
          $scope.order.USER_LAT = $scope.map.control.getGMap().center.lat();
          $scope.order.USER_LNG = $scope.map.control.getGMap().center.lng();
          $scope.order.TB_USER_ID = $scope.order.user.ID;
          $scope.order.TB_USER_ID_EMPLOYEE = $scope.order.employee.ID;

          $resource(`${APIURL}/admin/subscription/orders`).save($scope.order).$promise
            .then(() => {
              $location.path('/orders/subscription');
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };

        // 사용자 검색
        $scope.openUsers = () => {
          $scope.userSearch = { query: '', result: [] };
          jQuery('#modal-1').modal('show');
        };
        $scope.searchUsers = () => {
          $resource(`${APIURL}/admin/users`).get({ q: $scope.userSearch.query, count: -1 }, (data) => {
            $scope.userSearch.result = data.users;
            console.log(data);
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };
        $scope.selectUser = (user) => {
          $scope.order.user = user;
          $resource(`${APIURL}/admin/users/${user.ID}/usercars`).get({ COUNTRY_CODE: $scope.countryCode }, (data) => {
            console.log(data);
            $scope.usercars = data.usercars;
            jQuery('#modal-1').modal('hide');
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };
        // 테크니션 검색
        $scope.openEmployees = () => {
          $resource(`${APIURL}/admin/employees/available`).get((data) => {
            $scope.employeeSearch = { query: '', result: data.employees };
            jQuery('#modal-2').modal('show');
            console.log(data);
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };
        $scope.searchEmployee = () => {
          $resource(`${APIURL}/admin/employees/available`).get({ q: $scope.employeeSearch.query, count: -1 }, (data) => {
            $scope.employeeSearch.result = data.employees;
            console.log(data);
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };
        $scope.selectEmployee = (user) => {
          $scope.order.employee = user;
          jQuery('#modal-2').modal('hide');
        };

        // 상품 목록
        $scope.requestProducts = () => {
          let usercar = null;
          for (let idx = 0; idx <= $scope.usercars.length; idx += 1) {
            if ($scope.usercars[idx].ID == $scope.order.TB_USER_CARINFO_ID) { // eslint-disable-line
              usercar = $scope.usercars[idx];
              break;
            }
          }
          if (usercar === null) {
            return;
          }
          $resource(`${APIURL}/admin/subscription/products/${usercar.GOODS_ID}`).get((data) => {
            $scope.products = data.products.map((product) => {
              if (product.REPEAT_TYPE === 1) {
                product.REPEAT_TYPE_TXT = $translate.instant('월 1회(4주마다)');
              } else if (product.REPEAT_TYPE === 2) {
                product.REPEAT_TYPE_TXT = $translate.instant('월 2회(격주마다)');
              } else if (product.REPEAT_TYPE === 4) {
                product.REPEAT_TYPE_TXT = $translate.instant('월 4회(매주마다)');
              }
              return product;
            });
            console.log(data);
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };

        // Google Map 처리
        uiGmapGoogleMapApi.then(() => {
          $resource(`${APIURL}/maps/areas`).get((data) => {
            data.areas.forEach((area) => {
              let path = area.POLYLINE;
              path = path.replace('\n', '\\n');
              const polyline = new google.maps.Polygon({
                path: google.maps.geometry.encoding.decodePath(path),
                geodesic: true,
                strokeColor: '#5694cc',
                fillColor: '#5694cc',
                strokeOpacity: 1.0,
                fillOpacity: 0.1,
                strokeWeight: 2,
              });
              polyline.setMap($scope.map.control.getGMap());
            });
            $scope.marker = new google.maps.Marker({
              position: { lat: $scope.map.center.latitude, lng: $scope.map.center.longitude },
              map: $scope.map.control.getGMap(),
            });
            $scope.updateAddress($scope.map.center.latitude, $scope.map.center.longitude);
            $scope.map.control.getGMap().addListener('drag', () => {
              $scope.marker.setPosition(new google.maps.LatLng($scope.map.control.getGMap().center.lat(), $scope.map.control.getGMap().center.lng()));
            });
            $scope.map.control.getGMap().addListener('dragend', () => {
              $scope.updateAddress($scope.map.control.getGMap().center.lat(), $scope.map.control.getGMap().center.lng());
            });
            $resource(`${APIURL}/admin/maps/center`).get((centerInfo) => {
              CenterInfo.updateCenter(centerInfo.center.latitude, centerInfo.center.longitude);
              const latLng = new google.maps.LatLng({ lat: CenterInfo.center.latitude, lng: CenterInfo.center.longitude });
              $scope.map.control.getGMap().panTo(latLng);
              $scope.marker.setPosition(latLng);
              $scope.updateAddress($scope.map.control.getGMap().center.lat(), $scope.map.control.getGMap().center.lng());
            });
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        });
        $scope.updateAddress = (lat, lng) => {
          $resource(`${APIURL}/maps/areas/address`).get({ LAT: lat, LON: lng }, (data) => {
            $scope.order.USER_ADDR = data.address;
          });
        };
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/orders-subscription-add/orders-subscription-add.component.js